module.exports = __webpack_public_path__ + "static/media/fire-smoke.5575e26c.svg";